import React, { useEffect, useState } from "react";
import { Modal, ConfigProvider, Divider, Tabs } from "antd";
import useUserStore from "../../stores/store";
import useScrollLock from "../../hooks/useScrollLock";
import useTableManagementStorage from "../../stores/useTableManamentStore";
import { getFormatedTabItems } from "../../services/order-table-base-service";

/**
 * context = ADD_MORE_TABLE, ACTION_MODAL
 * @param {*} param0 
 * @returns 
 */
function FloorPlanModal({ openModal, context, addMoreTableHandler, actionModalHandler, onHandleCancel, params = {} }) {
  const { restaurantId, setNetworkCall } = useUserStore();
  const { layoutFloors, modalActionMode, floorTabActiveKey } = useTableManagementStorage();
  const [tabItems, setTabItems] = useState([]);
  const [modalOkText, setModalOkText] = useState('Save');

  // Lock scroll when modal is open
  useScrollLock(openModal);

  const handleOk = async () => {
    if (context === 'ADD_MORE_TABLE') {
      addMoreTableHandler();
      return;
    }

    actionModalHandler(modalActionMode);
  };

  const handleCancel = () => {
    onHandleCancel(modalActionMode);
  };
  
  /*Use effects*/
  useEffect(() => {
    setTabItems(getFormatedTabItems(restaurantId, Object.values(layoutFloors), true))
  }, [layoutFloors]);

  useEffect(() => {
    if (modalActionMode === 'ADD_MORE_TABLE') {
      setModalOkText("Add");
    } else if (modalActionMode === 'MERGE_ORDER') {
      setModalOkText('Merge');
    } else if (modalActionMode === 'TRANSFER_ORDER') {
      setModalOkText('Transfer');
    } else {
      setModalOkText('Ok');
    }
  }, [modalActionMode])

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        maskClosable={false}
        open={openModal}
        okText={modalOkText}
        okButtonProps={{
          style: {
            backgroundColor: "#2EC114",
            color: "#FFFFFF",
            fontFamily: "ubold",
            border: "none",
            padding: "8px 16px",
            borderRadius: "4px",
            cursor: "pointer",
            marginRight: "10px",
          },
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#FF4D4F",
            color: "#FFFFFF",
            fontFamily: "ubold",
            border: "none",
            padding: "8px 16px",
            borderRadius: "4px",
            cursor: "pointer",
            marginRight: "10px",
          },
        }}
        onOk={handleOk}
        onCancel={handleCancel}
        width={"80%"}
        style={{ top: 0 }}
        styles={{
          body: {
            maxHeight: "90vh",
            overflowY: "auto",
          },
        }}
        closable={false}
      >
        <div className="flex flex-col font-uregular">
          <div className="text-xl font-ubold mb-5">Floor Plans</div>
          <div className="flex flex-col">
            <Tabs defaultActiveKey={floorTabActiveKey} type="card" size="middle" style={{ marginBottom: 32 }} items={tabItems} />
          </div>
          <Divider />
        </div>
      </Modal>
    </ConfigProvider>
  );
}

export default FloorPlanModal;
